import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ProfileStep extends Component {
  static propTypes = {
    onNext: PropTypes.func,
    onBack: PropTypes.func,
  }

  onNext = (e) => {
    e.preventDefault();
    this.props.onNext();
  }

  onBack = (e) => {
    e.preventDefault();
    this.props.onBack();
  }

  render() {
    return (
      <div className="profile-step">
        <h1 className="profile-step__title leading-3">{ this.props.title }</h1>
        <div className="profile-step__content">
          { this.props.onBack && <button className="button button--secondary profile-step__button" onClick={this.onBack}>Back</button> }
          { this.props.onNext && <button className="button profile-step__button" onClick={this.onNext}>Next</button> }
        </div>
      </div>
    )
  }
}
